const LOCALHOST = "https://sigrl.onrender.com" 
const BACKEND_URL = "https://sigrlcum.mairie-mahajanga.mg" ;
const E_immatriculation = "https://e-immatriculationcum.mairie-mahajanga.mg" ;
const E_immatriculation_URL = "https://e-immatriculation.onrender.com" 
const COMMUNE_URL = "https://commune-5avu.onrender.com";
const LOCAL_URL = "http://localhost:3000"
const URL = "http://localhost:5000"
const IM = "http://localhost:3500"
exports = module.exports = {
    LOCALHOST,
    BACKEND_URL,
    E_immatriculation,
    COMMUNE_URL ,
    E_immatriculation_URL,
    LOCAL_URL,
    URL,
    IM
}